module.exports = __webpack_public_path__ + "static/media/stopwatch.459a71b7.svg";